import React from 'react';
import { skillsData } from '../data';
import { Zoom } from 'react-reveal';

const Skills = () => {
  const createTriangleRows = (data) => {
    const rows = [];
    let itemsRemaining = data.length;
    let rowCount = 6;

    while (itemsRemaining > 0) {
      const rowItems = data.slice(rows.flat().length, rows.flat().length + rowCount);
      rows.push(rowItems);
      itemsRemaining -= rowItems.length;
      rowCount -= 1;
    }

    return rows;
  };

  const rows = createTriangleRows(skillsData);

  return (
    <section className='bg-black py-12'>
      <div className='container mx-auto'>
        <div className='py-10 flex flex-col'>
          <Zoom>
            <h1 tabIndex={0} className="text-6xl text-white font-bold leading-0 text-center">
              What <span className="text-accent">I Know</span>
            </h1>
          </Zoom>

          <div className='mt-16 py-20 flex flex-col items-center gap-16'>
            {/* Responsive grid for small screens */}
            <div className='flex flex-wrap gap-12 md:hidden'>
              {skillsData.map((skill) => (
                <div className='relative group block-container w-20 h-20' key={skill.name}>
                  <div className='btn-back rounded-xl' />
                  <div className='btn-front rounded-xl flex justify-center items-center'>
                    <img
                      src={skill.imageUrl}
                      alt={skill.name}
                      className='w-1/2 h-1/2 object-contain'
                    />
                  </div>
                  {/* Tooltip */}
                  <div className='absolute -bottom-10 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black text-white text-sm font-medium py-1 px-2 rounded shadow-lg'>
                    {skill.name}
                  </div>
                </div>
              ))}
            </div>

            {/* Triangle layout for medium and larger screens */}
            <div className='hidden md:flex md:flex-col items-center gap-16'>
              {rows.map((row, rowIndex) => (
                <Zoom key={rowIndex} cascade delay={rowIndex * 200}>
                  <div className='flex gap-16 justify-center'>
                    {row.map((skill) => (
                      <div className='relative group block-container w-20 h-20 md:w-24 md:h-24' key={skill.name}>
                        <div className='btn-back rounded-xl' />
                        <div className='btn-front rounded-xl flex justify-center items-center'>
                          <img
                            src={skill.imageUrl}
                            alt={skill.name}
                            className='w-1/2 h-1/2 object-contain'
                          />
                        </div>
                        {/* Tooltip */}
                        <div className='absolute -bottom-12 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black text-white text-sm font-medium py-1 px-2 rounded shadow-lg'>
                          {skill.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </Zoom>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
